import mapKnownValues from "@/utils/mapKnownValues";

export type StationTransactionSessionAPIResponse = {
  sessionId: string;
  sessionStartDateTime: string; // Date
  sessionEndDateTime: string; // Date
  sessionConnectionTime: number;
  durationState_C: number;
  sessionKWH: number;
  sessionMaxDemandKW: number;
  sessionAverageDemandKW: number;
  evseNbrOfPorts: number;
  drEventCalled: string;
  drEventParticipated: string;
  jsonData: Record<string, string>;
};

export default class StationTransactionSession {
  sessionId = "";
  sessionStartDateTime = new Date();
  sessionEndDateTime = new Date();
  sessionConnectionTime = -1;
  durationState_C = -1;
  sessionKWH = -1;
  sessionMaxDemandKW = -1;
  sessionAverageDemandKW = -1;
  evseNbrOfPorts = -1;
  drEventCalled = "";
  drEventParticipated = "";
  jsonData?: Record<string, string> = {};

  constructor(params: Partial<StationTransactionSession> = {}) {
    mapKnownValues(this, params);
  }

  static fromAPI(response: StationTransactionSessionAPIResponse) {
    return new StationTransactionSession({
      ...response,
      sessionStartDateTime: new Date(response.sessionStartDateTime),
      sessionEndDateTime: new Date(response.sessionEndDateTime)
    });
  }
}
